import {NetworkInstance} from "@goodgamestudios/world-assignment";

export class TestInstanceVO extends NetworkInstance {
    constructor() {
        super();
        this._type = "Test";
    }
}
